import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';
import { useSpecificProductApi } from '../../../hooks/useSpecificProductApi';
import  ProductDetails  from '../../specificProductLayout'; 
import { CartContext } from '../../cartContext'; 
// import useFetchRelatedProducts from '../../../hooks/relatedProducts';
// import {useRelatedProductsBySupplier} from '../../../hooks/relatedProducts'; 
import RelatedProducts from '../../relatedProducts';
import { Image } from 'react-bootstrap';
//import useProductAndRelatedProducts from '../../../hooks/productAndRelatedProduct';
// import useProductAndRelatedProductsBySupplier from '../../../hooks/relatedProducts';
import specProdPageCSS from './specProdPage.module.css';
import TechnicalInformation from '../../technicalInfo';
import PdfModal from '../../pdfModal';
import SameCategoryProducts from '../../sameCategoryProducts';
import defaultLogo from '../../../images/Logo.png';
import CustomDropdownFR from '../../customDropdownFR';
import BackButton from '../../backButton';


export function Product() {
  const { id } = useParams();
  const { product, relatedProducts, sameCategoryProducts, isLoading, isError } = useSpecificProductApi(id);
  const { addToCart } = useContext(CartContext);

  const specificProduct = product;
  //const consumables = product.data.attributes.forbruksvarers.data;
  // console.log(specificProduct);
  // console.log(sameCategoryProducts);
  const relatedProductsArray = relatedProducts;
  const visibleSameCategoryProducts = sameCategoryProducts.filter(product => product.attributes.visible);

  console.log(visibleSameCategoryProducts);

  // const onButtonAddToCart = () => {
  //   if (specificProduct) {
  //     addToCart(specificProduct);
  //   }
  // };
  const onButtonAddToCart = (selectedVoltage) => {
    if (specificProduct) {
      addToCart({ ...specificProduct, selectedVoltage });
    }
  };

  if (isLoading || !product) {
    return <div className="text-secondary text-center">Loading...</div>;
  }

  if (isError) {
    return <div className="text-secondary text-center">Error</div>;
  }

  const consumables = product.data.attributes.consumable_products.data;

  const imageUrl = product.data.attributes.image?.data?.attributes?.url || defaultLogo;

  return (
    // <div className={specProdPageCSS.parent}>
    //   <div className={`${specProdPageCSS.container1}`}>
    //     <div className={specProdPageCSS.testContainer}>
    //       <div className={specProdPageCSS.testSubContainer1}>
    //         <div className={`${specProdPageCSS.container2}`}>
    //           <div className={specProdPageCSS.imageContainer}>
    //             <Image src={imageUrl} fluid alt={product.data.attributes.name}/>
    //           </div>
    //           <div className={specProdPageCSS.subContainer}>
    //             <TechnicalInformation product={specificProduct} />
    //             <PdfModal product={specificProduct} />
    //           </div>
    //         </div>
    //         <div className={specProdPageCSS.container3}>
    //           <ProductDetails product={specificProduct} onButtonAddToCart={onButtonAddToCart} />
    //         </div>
    //       </div>
    //       <div className={specProdPageCSS.testSubConsumeables}>
    //         <CustomDropdownFR 
    //           openButtonTitle="Forbruksvarer"
    //           content={consumables}
    //           onClick={(item) => addToCart(item)}
    //           type="list"
    //         />
    //       </div>
    //       <div className={specProdPageCSS.testSubContainer2}>
    //         <RelatedProducts relatedProducts={relatedProductsArray} />
    //       </div>
    //     </div>
    //     <div className={specProdPageCSS.container4}>
    //         <SameCategoryProducts sameCategoryProducts={visibleSameCategoryProducts} />
    //     </div>
    //   </div>
    // </div>
    <div className={specProdPageCSS.parent}>
    <div className={`${specProdPageCSS.container1}`}>
      <div className={specProdPageCSS.testContainer}>
        <div className={specProdPageCSS.testSubContainer1}>
          <div className={`${specProdPageCSS.container2}`}>
          <div className="col-12">
                          <div className="col-2 ms-2">
                              <BackButton/>
                          </div>
                      </div>
            <div className={specProdPageCSS.imageContainer}>
              <Image src={imageUrl} fluid alt={product.data.attributes.name} />
            </div>
            <div className={specProdPageCSS.subContainer}>
              <TechnicalInformation product={specificProduct} />
              <PdfModal product={specificProduct} />
            </div>
          </div>
          <div className={specProdPageCSS.container3}>
            <ProductDetails product={specificProduct} onButtonAddToCart={onButtonAddToCart} />
            <div className={specProdPageCSS.forbruk}>
              <CustomDropdownFR
              openButtonTitle="Forbruksvarer"
              content={consumables}
              onClick={(item) => addToCart(item)}
              type="list"
            />
            </div>
          </div>
        </div>
        {/* <div className={specProdPageCSS.testSubConsumeables}>
          <CustomDropdownFR
            openButtonTitle="Forbruksvarer"
            content={consumables}
            onClick={(item) => addToCart(item)}
            type="list"
          />
        </div> */}
        <div className={specProdPageCSS.testSubContainer2}>
          <RelatedProducts relatedProducts={relatedProductsArray} />
        </div>
      </div>
      <div className={specProdPageCSS.container4}>
        <SameCategoryProducts sameCategoryProducts={visibleSameCategoryProducts} />
      </div>
    </div>
  </div>
  );
}

export default Product;

